import { render, staticRenderFns } from "./SaveSearchSidePanel.vue?vue&type=template&id=68ed050e&scoped=true&"
import script from "./SaveSearchSidePanel.vue?vue&type=script&lang=ts&"
export * from "./SaveSearchSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed050e",
  null
  
)

export default component.exports